export default "__VITE_ASSET__DSsAq1hH__"